import { BenefitResource, benefitResource } from '@witkac/kartamiejska-resources';
import { Benefit } from '@witkac/kartamiejska-shared';

import store from '@/store/store';
import { EntityModule } from '../entity.module';
import available from './availableBenefits.module';

/**
 * Moduł usług partnera
 *
 * @export
 * @class BenefitsModule
 * @extends {AbstractModule<BenefitResource>}
 */
export class BenefitsModule extends EntityModule<Benefit, BenefitResource> {
  public modules = {
    available
  };

  constructor() {
    super(benefitResource);

    this.mutations = {
      ...this.mutations,
      /**
       * Dodaje usługę do listy
       *
       * @param localState stan lokalny
       * @param data dane do wysłania do API
       */
      add(): void {
        store.dispatch('partners/benefits/list', {
          partnerId: (store.state as any).partners.id,
          count: 0,
          withInactiveCategories: true
        });
      },
      /**
       * Aktualizuje usługę na liście
       *
       * @param localState stan lokalny
       * @param data dane do wysłania do API
       */
      update(): void {
        store.dispatch('partners/benefits/list', {
          partnerId: (store.state as any).partners.id,
          count: 0,
          withInactiveCategories: true
        });
      }
    };
  }
}

export default new BenefitsModule();
